import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/zero.pdf'; 
import { Helmet } from 'react-helmet';
import ZeroMobile from '../images/zero.png';

function Zero() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        Sämtliche schriften und briefe series VII, volume 1<br />
        Deutsche Akademie der Wissenschaften (ed)<br />
        p 675<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        Date: end 1672 - spring 1673 (?)<br /><br />
        Translated from the Latin<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (246k)</Link><br /><br />
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>On the Powers of 0</title>
            <meta name="description" content="An English translation of ON THE POWERS OF 0 by Gottfried Wilhelm Leibniz, from end 1672 - spring 1673 (?)" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <td className="pdf-container">
                    <h2 className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ON THE POWERS OF 0</h2>
                    {isMobile ? renderLinks() : ''}
                    {isMobile ? <img src={ZeroMobile} width="100%"/> : <embed src={pdf} className="responsive-embed"/>}
		              </td>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Zero;